import { Collection } from '@/types/documents/documents.types';

// Checks collections' files objects to determine if a file is in a collection
export const getFileCollectionIdHelper = (
  fileId: string,
  allCollections: Collection[]
): string | null => {
  for (const collection of allCollections) {
    const collectionId = collection.id || collection.collectionId;
    if (collectionId && collection.files && fileId in collection.files) {
      return collectionId;
    }
  }
  return null;
};
